module.exports = __webpack_public_path__ + "static/media/home.a28b8a16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/home.svg
// module id = 1364
// module chunks = 0